/* global window */
const canUseDom = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement)

module.exports = canUseDom
